module.exports = __webpack_public_path__ + "static/ogre-84f0639047beb3ee76b4daeaf6739243.jpeg";